import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, Dashboard, Category, Group, IValueViewModel, ObjectUser, IApplicationConfiguration, ErrorLevel, ISortConfiguration, KeyValuePair, RefreshClickData } from '../../../models';
import { WidgetContainerBase } from '../../../states';
import { IRootScope } from 'IRootScope';
import { ICurrentApplicationService, IDashboardFactory, IAuthorizationService, ILoggerService, IwidgetService, IConfigurationService, WidgetMappingResult, IDashboardLoadService, IStoreService, IRequestService } from '../../../services';
import { IDashboardActionsService, Store, StoreElement } from '../../../stateManagement';
import { Roles, isEditMode, formDirtyChanged, refreshClick, treeUpdated, dashboardUpdated, WideError, missingSeries, guidEmpty } from '../../../common';
import { IWidget, DashboardThumbnailWidget } from '../../../widgets';


export interface IDashboardsParams extends angular.ui.IStateParamsService {
    categoryGuid?: string;
}

class DashboardsStateController extends WidgetContainerBase implements angular.IComponentController {
    app: IApplicationConfiguration;
    apiUrl: string;
    applicationGuid: string;
    categories: Category[] = [];
    categoryGuid: string;
    currentInterval: any;
    currentBeginDate: string;
    currentEndDate: string;
    dashboards: Dashboard[] = [];
    filteredCategoryName: string;
    filteredCategory: Category;
    filtered: DashboardThumbnailWidget[];
    formController: any;
    groups: Group[] = [];
    hasManualInputRole: boolean;
    isLoaded: boolean = false;
    isLoading: boolean;
    isLoadingData: boolean;
    isDataLoaded: boolean;
    loadingMessage: string;
    newCategories: KeyValuePair<string, string>[];// From the contextual
    selectedItem: DashboardThumbnailWidget;
    sortConfig: ISortConfiguration = {
        draggabe: '.dashboard',
        animation: 150,
        onSort: evt => this.sort(evt),
        disabled: true
    };
    users: { [guid: string]: ObjectUser };
    validationEnabled: boolean;
    valueViewModels: IValueViewModel[];

    private _garbages: (() => void)[] = [];

    static $inject = [
        '$scope',
        '$rootScope',
        '$timeout',
        '$state',
        '$stateParams',
        'storeService',
        'currentApplicationService',
        'dashboardFactory',
        'dashboardActionsService',
        'authorizationService',
        'loggerService',
        'widgetService',
        'configurationService',
        'dashboardLoadService',
        'requestService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$rootScope: IRootScope,
        private _$timeout: angular.ITimeoutService,
        private _$state: angular.ui.IStateService,
        private _$stateParams: IDashboardsParams,
        private _storeService: IStoreService,
        private _currentApplicationService: ICurrentApplicationService,
        private _dashboardFactory: IDashboardFactory,
        private _dashboardActionsService: IDashboardActionsService,
        private _authorizationService: IAuthorizationService,
        private _loggerService: ILoggerService,
        private _widgetService: IwidgetService,
        private _configurationService: IConfigurationService,
        private _dashboardLoadService: IDashboardLoadService,
        private _requestService: IRequestService) {
        super(_$rootScope);
        this.hasManualInputRole = this._authorizationService.isInRoles(Roles.manualInputRoles);
    }

    $onInit() {
        this.isDataLoaded = false;
        this.categoryGuid = this._$stateParams.categoryGuid;
        const startPos: { col: number; row: number } = { col: 0, row: 0 };

        this.gridsterOptions.draggable.start = (event, element, widget) => {
            startPos.col = widget.col;
            startPos.row = widget.row;
        };

        this.gridsterOptions.draggable.stop = (event, element, widget) => {
            if (startPos.col !== widget.col || startPos.row !== widget.row) {
                const dashboards = (this.widgetList as DashboardThumbnailWidget[])
                    .map(tn => tn.dashboard);
                this._storeService.dispatchers().dashboards
                    .updateMany(dashboards, true);
            }
        };

        this.on(isEditMode, () => {
            super.onIsEditMode(true, false);
            this.sortConfig.disabled = !this._$rootScope.isEditMode || !this.canDrag();
            this.isEditMode = this._$rootScope.isEditMode;
        });

        this.on(formDirtyChanged, (event, formDirty) => {
            if (this.canDrag()) {
                this.sortConfig.disabled = !this._$rootScope.isEditMode || formDirty || !this.canDrag();
            }
            this.updateErrors();
        });

        this.on(refreshClick, (event, data: RefreshClickData) => {
            if (this.dashboards && this.categories && this.users) {
                this.widgetList = this.refresh(this.dashboards, this.categories, this.users, !!data.force);
            }
        });

        const app = this._currentApplicationService.getApplicationConfiguration();
        this.validationEnabled = (app) ? app.validationEnabled : false;
        this.app = app;
        this.apiUrl = this._configurationService.configuration.apiUrl;

        this._garbages.push(this._$scope.$watchGroup(
            [() => this.currentBeginDate, () => this.currentEndDate],
            () => this.currentInterval = { startDate: this.currentBeginDate, endDate: this.currentEndDate }
        ));

        // connect to Store
        this.isLoaded = false;
        this.isLoading = true;
        this._garbages.push(this._storeService.register(
            store => this.refreshStore(store),
            [
                StoreElement.ValueViewModels,
                StoreElement.Groups,
                StoreElement.Categories,
                StoreElement.DashboarUsers,
                StoreElement.Dashboards,
            ]
        ));
    }

    $onDestroy() {
        this._garbages.forEach(g => g());
    }

    getClass = (item: any): any => {
        if (item.getError && item.getError()) {
            const errorClass = !item.getError || item.getError().classed;
            const result: any = {};
            if (errorClass) {
                result[errorClass] = true;
            }
            if (this.isSelected(item)) {
                result.bordered = true;
            }
            return result;
        }
    }

    filterByCategory(dashboards: Dashboard[], categories: Category[]): Dashboard[] {
        if (this.categoryGuid) {
            const foundCategory: Category[] = categories.filter(c => c.guid === this.categoryGuid);
            this.filteredCategory = (foundCategory && foundCategory.length > 0) ? foundCategory[0] : null;
            if (this.filteredCategory) {
                this.filteredCategoryName = this.filteredCategory.name;
            }
            dashboards = dashboards
                .filter((d: Dashboard) =>
                    d.categories &&
                    d.categories.length > 0 &&
                    d.categories.indexOf(this.categoryGuid) >= 0);

        }
        return dashboards;
    }

    unSelectItem($event): void {
        if (!$event.isDefaultPrevented()) {
            this.selectItem(null, $event);
        }
    }

    selectItem(item: DashboardThumbnailWidget, $event): void {
        if (this._$rootScope.isEditMode) {
            if (!this.formController || !this.formController.$dirty) {
                this.setSelectedItem(item);
            } else {
                this._loggerService
                    .logWarning('There are pending changes. Save or cancel before selecting another item.');
            }
        } else {
            if (item && item.guid) {
                this._requestService.cancelPendingRequest();
                this._$state.go('dashboard', { dashboardName: item.guid, groupGuid: item.referenceGroup });
            }
        }
        $event.preventDefault();
    }

    deleteItem(guid: string): void {
        this._storeService.dispatchers().dashboards
            .deleteOne(guid)
            .then(data => {
                this.deleteOrphanCategories(this.dashboards, this.categories);
                this._$rootScope.$broadcast(treeUpdated);
                this.setSelectedItem(null);
            });
    }

    onDuplicated(dashboard: Dashboard) {
        const thumbails = this.refresh(this.dashboards, this.categories, this.users);
        this.setSelectedItem(_.find(thumbails, d => d.guid === dashboard.guid));
    }

    canDrag() {
        return (this.categoryGuid) ? false : true;
    }

    drop(item, dragObject) {
        if (dragObject && dragObject.type) {
            const dashboard = this._dashboardFactory.createDashboard(dragObject.type);
            if (dashboard) {
                dashboard.name = dragObject.title;
                if (this.categoryGuid) {
                    dashboard.categories.push(this.categoryGuid);
                }
                this._storeService.dispatchers().dashboards
                    .addOne(dashboard, true)
                    .then(data => this._$timeout(() => this.selectAndScrollToLast()))
                    .catch(reason => this._loggerService.logError(reason));
            }
        }
    }

    private selectAndScrollToLast() {
        if (this.widgetList.length > 0) {
            const widget = this.widgetList[this.widgetList.length - 1];
            this.setSelectedItem(widget);
            let scrolled = false;
            const listener = this._$scope.$watch(() => {
                if (!scrolled) {
                    if (widget) {
                        const element = document.getElementById(`item${widget.guid}`);
                        if (element) {
                            element.scrollIntoView();
                            scrolled = true;
                            listener();
                        }
                    }
                }
            });
        }
    }

    update() {
        const { dashboard } = this.selectedItem;
        const originalCategoryGuids = this.categories.map(d => d.guid);
        const newCategories: Category[] = this.newCategories
            .filter(d => originalCategoryGuids.indexOf(d.key) < 0)
            .map(d => {
                const retVal = new Category();
                retVal.guid = d.key;
                retVal.name = d.value;
                return retVal;
            });
        const usedCategories: string[] = [].concat(... this.dashboards.map(d => d.categories));
        const categoriesToDelete = originalCategoryGuids.filter(d => usedCategories.indexOf(d) < 0);
        const service = this._storeService.dispatchers();
        this.isLoading = true;
        this.isLoaded = false;
        // sanitize dashboard reference group
        if (dashboard.groupGuids.length === 0 && dashboard.groupTypes.length === 0) {
            dashboard.referenceGroup = undefined;
        }

        return service.categories
            .addMany(newCategories)
            .then(() => service.dashboards.updateMany([dashboard], true))
            .then(() => service.categories.deleteMany(categoriesToDelete))
            // to make contextual pristine
            .then(() => false);
    }

    unselect() {
        this.setSelectedItem(null);
    }

    duplicate(dashboardGuid: string, newName: string, seriesRename: any[], groupsRename: any[]): angular.IPromise<any> {
        let mappings: WidgetMappingResult[];
        return this._storeService.dispatchers().dashboards
            .getOne(dashboardGuid)
            .then(original => this._widgetService.cloneDashboard(original, newName, seriesRename, groupsRename))
            .then(data => {
                mappings = data.mappingResults;
                mappings.forEach(m => {
                    if (m.mappings.irreplacible && m.mappings.irreplacible.length) {
                        m.mappings.irreplacible.forEach(mapping => {
                            this._loggerService.logWarning(`Series ${mapping.newVm.name} does not exist, series ${mapping.originalVm.name} kept in place in widget ${m.widget.name}.`);
                        });
                    }
                });
                return this._storeService.dispatchers().dashboards.addOne(data.copy, true);
            });
    }

    private refreshStore(store: Store) {
        const valueViewModels = _.values<IValueViewModel>(store.valueViewModels.dictionary);
        const groups = _.values<Group>(store.groups.dictionary);
        const categories = _.values<Category>(store.categories.dictionary);
        const dashboardUsersDic = store.dashboardUsers.dictionary;
        const dashboards = _.values(store.dashboards.dictionary);

        this.categories = categories;
        this.dashboards = dashboards;
        this.groups = groups;
        this.valueViewModels = valueViewModels;
        this.users = dashboardUsersDic;
        this.isLoading = false;
        this.isLoaded = true;
        this.widgetList = this.refresh(this.dashboards, this.categories, this.users) as IWidget[];
    }

    private on(event: string, listener: (ev: angular.IAngularEvent, ...args: any[]) => void) {
        this._garbages.push(this._$scope.$on(event, listener));
    }

    private sort(evt) {
        evt.models.forEach((s, i) => {
            s.sortOrder = i;
            s.dashboard.sortOrder = i;
        });
        this._storeService.dispatchers().dashboards
            .updateMany(evt.models.map(t => t.dashboard), true)
            .then(() => {
                this._$rootScope.$broadcast(dashboardUpdated);
                this._$rootScope.$broadcast(treeUpdated);
            })
            .catch(reason => {
                this._loggerService.logError(`Cannot update order of dashboards : ${reason}`);
            });
    }

    private refresh(dashboards: Dashboard[], categories: any[], users: { [guid: string]: ObjectUser }, force: boolean = false): DashboardThumbnailWidget[] {
        try {
            let widgetList: DashboardThumbnailWidget[] = [];
            const filteredDashboards = this.filterByCategory(dashboards, categories);
            if (filteredDashboards && filteredDashboards.length > 0) {
                widgetList = this._dashboardActionsService.getDashboardThumbnails(filteredDashboards);
                this.checkForWidgetsErrors(widgetList);
                widgetList = _.sortBy(widgetList, d => d.sortOrder);
                widgetList.forEach(w => {
                    (w as any).users = users[w.guid];
                });
            }
            return widgetList;
        } catch (e) {
            this._loggerService.logError(e);
            return [];
        }
    }

    private checkForWidgetsErrors(widgetList: DashboardThumbnailWidget[], force: boolean = false) {
        if (this.isLoaded) {
            const vmList = this.valueViewModels.map(v => v.guid);
            const groupList = this.groups.map(g => g.guid);
            let qualityWidgets = [];
            widgetList.forEach(thumbnail => {
                const widgets = thumbnail.configuration.widgets;
                const filtered = widgets.filter(w => !!w && !!w.configuration && w.configuration.qualityWidgetType !== undefined);
                qualityWidgets = qualityWidgets.concat(...filtered);
                widgets.forEach((widget: any) => {
                    if (widget && !!widget.readData) {
                        widget.readData();
                    }
                    if (this.hasMissing(widget, vmList, groupList)) {
                        (thumbnail as DashboardThumbnailWidget).addError(new WideError(ErrorLevel.Error, missingSeries));
                    }
                    if (!widget) {
                        console.log(`A widget is null in dashboard ${thumbnail.dashboard.name}`);
                    }
                });
                this.updateDashboardErrors(thumbnail as DashboardThumbnailWidget);
            });
            if (qualityWidgets.length > 0) {
                this.isDataLoaded = false;
                this.isLoadingData = true;
                this._$timeout(() => {
                    if (this.currentBeginDate && this.currentEndDate) {
                        this._dashboardLoadService
                            .refresh(qualityWidgets, this.currentBeginDate, this.currentEndDate, null, false, null, force)
                            .then(data => this._dashboardLoadService.assignValues(data, qualityWidgets))
                            .finally(() => {
                                this.isDataLoaded = true;
                                return this.isLoadingData = false;
                            });
                    }
                });
            } else {
                this.isDataLoaded = true;
                this.isLoadingData = false;
            }
        }
    }

    private updateDashboardErrors(w: DashboardThumbnailWidget): void {
        const groupRefOk = !w.dashboard.groupTypes || w.dashboard.groupTypes.length === 0 ||
            (w.dashboard.referenceGroup !== undefined && w.dashboard.referenceGroup !== guidEmpty);
        if (!groupRefOk) {
            w.addError(new WideError(ErrorLevel.Error, 'A reference group is required'));
        }
    }

    private hasMissing(w: IWidget, vmList: string[], groupList: string[]): boolean {
        const series = this._widgetService.getSeries(w);
        if (series) {
            const hasMissing = _.some(series, s => !s.isQuery
                && vmList.indexOf(s.guid) < 0
                && groupList.indexOf(s.guid) < 0);
            return hasMissing;
        }
        return false;
    }

    private updateErrors() {
        (this.widgetList as DashboardThumbnailWidget[])
            .forEach(thumbnail => {
                thumbnail.clearErrors();
                this.updateDashboardErrors(thumbnail as any);

                thumbnail.configuration.widgets.forEach(widget => {
                    if (this.hasMissing(widget, this.valueViewModels.map(v => v.guid), this.groups.map(g => g.guid))) {
                        thumbnail.addError(new WideError(ErrorLevel.Error, missingSeries));
                    }
                });

            });
    }

    /**
     * Delete categories not linked to any dashboard
     */
    private deleteOrphanCategories(dashboards: Dashboard[], categories: Category[]) {
        const categoryGuidToDelete = this._dashboardActionsService.getOrphanCategories(dashboards, categories);

        // Delete orphan categories
        this._storeService.dispatchers().categories
            .deleteMany(categoryGuidToDelete)
            .catch(reason => this._loggerService.logError('Error while deleting orphan categories: ' + reason));
    }
}

export const wtDashboardsState: ComponentDefinition = {
    componentId: 'wtDashboardsState',
    controller: DashboardsStateController,
    template: require('./dashboardsState.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};